import { AtSymbolIcon } from "@heroicons/react/24/outline";
import { PhoneIcon } from "@heroicons/react/24/solid";
import placeholder from "../../components/images/placeholder.png";
import { employees } from "../../data/employees";
import Vacancies from "../../components/home/vacancies";

export const Stillinger = () => {
  return <Vacancies />;
};
